export const getLocationsDomain
  = (state: any) => state.locationsState;

export const selectPostshopLocatorDomain
  = (state: any) => state.postshopLocator;


// WEBPACK FOOTER //
// ./src/redux/selectors/domainSelectors.ts